import { Link, useLocation, useNavigate } from "react-router-dom";
import { FolderOpen, SignOut, HardHat } from "@phosphor-icons/react";
import { Wordmark } from "@/components/Wordmark";
import { useAuth } from "@/context/AuthContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const initials = (user?.name || "U").split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="user-menu-trigger" className="flex items-center gap-2 rounded-sm px-2 py-1 hover:bg-slate-100 transition-colors">
        {user?.picture ? (
          <img src={user.picture} alt="" className="h-8 w-8 rounded-sm object-cover" referrerPolicy="no-referrer" />
        ) : (
          <span className="h-8 w-8 rounded-sm bg-slate-900 text-white text-xs font-semibold flex items-center justify-center">{initials}</span>
        )}
        <span className="hidden sm:block text-sm font-medium text-slate-700 max-w-[160px] truncate">{user?.name}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>
          <div className="text-sm font-semibold">{user?.name}</div>
          <div className="text-xs text-slate-500 font-normal truncate">{user?.email}</div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid="logout-button" onClick={async () => { await logout(); navigate("/login"); }}>
          <SignOut className="mr-2" size={16} /> Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function AppShell({ children }) {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen bg-slate-50 flex">
      <aside className="hidden lg:flex w-64 shrink-0 flex-col bg-slate-900 text-slate-300 border-r border-slate-800 sticky top-0 h-screen">
        <div className="h-16 flex items-center px-6 border-b border-slate-800">
          <Link to="/projects" data-testid="sidebar-home-link"><Wordmark inverted size="sm" /></Link>
        </div>
        <nav className="p-3 space-y-1">
          <Link
            to="/projects"
            data-testid="sidebar-projects-link"
            className={`flex items-center gap-3 px-3 py-2 rounded-sm text-sm font-medium transition-colors ${pathname.startsWith("/projects") ? "bg-slate-800 text-white" : "hover:bg-slate-800/60"}`}
          >
            <FolderOpen size={18} weight="duotone" /> Projects
          </Link>
        </nav>
        <div className="mt-auto p-5 border-t border-slate-800 text-xs text-slate-500 leading-relaxed">
          <div className="flex items-center gap-2 text-slate-400 mb-1"><HardHat size={16} weight="duotone" /> EF INFRA</div>
          Jammu & Kashmir, India<br />BOQ Estimation & Profit Suite
        </div>
      </aside>
      <div className="flex-1 min-w-0 flex flex-col">
        <header className="h-16 sticky top-0 z-40 border-b border-slate-200 bg-white/90 backdrop-blur-md flex items-center justify-between px-4 sm:px-6 lg:px-8">
          <Link to="/projects" className="lg:hidden" data-testid="header-home-link"><Wordmark size="sm" /></Link>
          <div className="hidden lg:block text-xs uppercase tracking-[0.2em] text-slate-400 font-semibold">Estimation · Costing · Profit</div>
          <UserMenu />
        </header>
        <main className="flex-1 min-w-0">{children}</main>
      </div>
    </div>
  );
}
